<section class="relative max-w-96 bg-white rounded-2xl p-4 flex flex-col">
  <div class="flex flex-row items-center">
    <img
      class="w-32"
      src="https://res.cloudinary.com/superlikers/image/upload/v1777472487/solicitud_de_alta_2_sp9zo4.png"
      alt="" />

    <div class="flex flex-col gap-2 text-right">
      <h3 class="text-xl font-light text-[#F56B00]">Hola Empresario</h3>
      <div>
        <p class="font-italic text-balance text-theme-cobaltBlue text-sm">Para darte de alta en Modelo para Ganar, valida tu información.</p>
        <p class="font-italic text-balance text-theme-cobaltBlue text-sm">Completa el formulario y revisaremos tu solicitud.</p>
      </div>
    </div>
  </div>

  <form
    id="mundial-bees-form"
    class="flex flex-col gap-6 rounded-xl text-theme-mediumBlue2"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <section class="bg-theme-lightBlue2 p-4 rounded-2xl flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="codigoSap">
          Código SAP*
        </label>
        <input
          id="codigoSap"
          type="text"
          formControlName="codigoSap"
          placeholder="Ingresa tu código SAP"
          class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 px-4 text-sm" />
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="nombreCompleto">
          Nombre Completo*
        </label>
        <input
          id="nombreCompleto"
          type="text"
          formControlName="nombreCompleto"
          placeholder="Ingresa tu nombre completo"
          class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 pl-4 text-sm" />
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="modelorama">
          Modelorama*
        </label>
        <input
          id="modelorama"
          type="text"
          formControlName="modelorama"
          placeholder="Ingresa el nombre o identificador"
          class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 pl-4 text-sm" />
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="correo">
          Correo electrónico*
        </label>
        <input
          id="correo"
          type="email"
          formControlName="correo"
          placeholder="Ingresa tu correo electrónico"
          class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 pl-4 text-sm" />
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="telefono">
          Teléfono*
        </label>
        <div class="grid grid-cols-[60px,1fr] gap-2">
          <input
            id="lada"
            type="text"
            formControlName="lada"
            placeholder="+52"
            class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 pl-4 text-sm" />
          <input
            id="telefono"
            type="number"
            formControlName="telefono"
            placeholder="Ingresa tu número telefónico"
            class="rounded-xl border bg-theme-lightBlue3 border-theme-cobaltBlue py-2 pl-4 text-sm" />
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="firmoContrato">
          Ya firmaste contrato?*
        </label>
        <div class="grid grid-cols-2 gap-2 items-center justify-items-center">
          <label
            for="firmoContrato-si"
            class="flex gap-2 items-center">
            <input
              class="peer hidden"
              type="radio"
              id="firmoContrato-si"
              formControlName="firmoContrato"
              value="si" />
            <span
              class="rounded-full size-5 shrink-0 bg-white shadow-inset-custom-2 peer-checked:bg-[url('https://res.cloudinary.com/superlikers/image/upload/v1768929156/NICE_3_vrxmdw.png')] peer-checked:bg-cover peer-checked:bg-center peer-checked:shadow-none peer-checked:border-0 border border-theme-cobaltBlue"></span>
            Sí
          </label>
          <label
            for="firmoContrato-no"
            class="flex gap-2 items-center">
            <input
              class="peer hidden"
              type="radio"
              id="firmoContrato-no"
              formControlName="firmoContrato"
              value="no" />
            <span
              class="rounded-full size-5 shrink-0 bg-white shadow-inset-custom-2 peer-checked:bg-[url('https://res.cloudinary.com/superlikers/image/upload/v1768929156/NICE_3_vrxmdw.png')] peer-checked:bg-cover peer-checked:bg-center peer-checked:shadow-none peer-checked:border-0 border border-theme-cobaltBlue"></span>
            No
          </label>
        </div>
      </div>

      <div class="bg-theme-lightBlue3 flex items-center gap-4 rounded-lg p-2">
        <img
          class="w-20"
          src="https://res.cloudinary.com/superlikers/image/upload/v1777472487/solicitud_de_alta_1_bxtgur.png"
          alt="" />
        <p class="text-sm font-light text-balance">Si ya firmaste tu contrato, deberías haber recibido un correo con tu invitación.</p>
      </div>

      <div class="flex flex-col gap-1">
        <label
          class="text-theme-mediumBlue1 font-light"
          for="encontroInvitacion">
          Después de revisar tu correo (incluyendo spam), ¿encontraste tu invitación a Modelo Para Ganar?*
        </label>
        <div class="grid grid-cols-2 gap-2 items-center justify-items-center">
          <label
            for="encontroInvitacion-si"
            class="flex gap-2 items-center">
            <input
              class="peer hidden"
              type="radio"
              id="encontroInvitacion-si"
              formControlName="encontroInvitacion"
              value="si" />
            <span
              class="rounded-full size-5 shrink-0 bg-white shadow-inset-custom-2 peer-checked:bg-[url('https://res.cloudinary.com/superlikers/image/upload/v1768929156/NICE_3_vrxmdw.png')] peer-checked:bg-cover peer-checked:bg-center peer-checked:shadow-none peer-checked:border-0 border border-theme-cobaltBlue"></span>
            Sí
          </label>
          <label
            for="encontroInvitacion-no"
            class="flex gap-2 items-center">
            <input
              class="peer hidden"
              type="radio"
              id="encontroInvitacion-no"
              formControlName="encontroInvitacion"
              value="no" />
            <span
              class="rounded-full size-5 shrink-0 bg-white shadow-inset-custom-2 peer-checked:bg-[url('https://res.cloudinary.com/superlikers/image/upload/v1768929156/NICE_3_vrxmdw.png')] peer-checked:bg-cover peer-checked:bg-center peer-checked:shadow-none peer-checked:border-0 border border-theme-cobaltBlue"></span>
            No
          </label>
        </div>
      </div>
    </section>

    <button
      class="button1"
      [disabled]="form.invalid || loading()"
      form="mundial-bees-form"
      type="submit">
      {{ loading() ? 'Enviando...' : 'Enviar Solicitud' }}
    </button>
  </form>
</section>
